import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import SalesRuleForm from 'Services/ProductManagement/Features/SalesRule/Components/SalesRuleForm'
import { SELECTED_SALES_RULE_PARAMETER_KEY } from 'Services/ProductManagement/Features/SalesRule/Hooks/useSalesRulesWithParams'
import { useGetSingleSalesRuleQuery } from 'Services/ProductManagement/Features/SalesRule/salesRuleApi'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export default function SalesRuleEditPage() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/settings/sales-rules`
  const { id } = useParams()
  const previousLocation = usePreviousLocation(
    `${baseUrl}?${SELECTED_SALES_RULE_PARAMETER_KEY}=${id}`
  )

  const { data: singleExtensionSalesRule = null, isLoading: singleLoading } =
    useGetSingleSalesRuleQuery(id as string, {
      skip: !id,
      refetchOnMountOrArgChange: true
    })

  const breadcrumbs = [
    {
      title: t`Settings`
    },
    {
      title: t`Sales rules`,
      link: baseUrl
    },
    {
      title: singleExtensionSalesRule ? singleExtensionSalesRule.name : ''
    }
  ]

  const isLoading = singleLoading

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit sales rule`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        {singleExtensionSalesRule && (
          <SalesRuleForm salesRule={singleExtensionSalesRule} successBaseUrl={previousLocation} />
        )}
      </WithLoader>
    </Box>
  )
}
